import { createRoot } from 'react-dom/client';

const roots = new WeakMap();

export function renderInto(container, element) {
    let root = roots.get(container);

    if (!root) {
        root = createRoot(container);
        roots.set(container, root);
    }

    root.render(element);

    return root;
}

export function renderIntoWhenReady(containerId, element) {
    const container = document.getElementById(containerId);

    if (container) {
        renderInto(container, element);

        return;
    }

    const observer = new MutationObserver(() => {
        const target = document.getElementById(containerId);

        if (target) {
            observer.disconnect();
            renderInto(target, element);
        }
    });

    observer.observe(document.documentElement, {childList: true, subtree: true});
}
